export enum TournamentStatus {
	SCHEDULED = "scheduled",
	PLAYING = "playing",
	SUSPENDED = "suspended",
	POSTPONED = "postponed",
	COMPLETE = "complete",
	CANCELED = "canceled",
}
